export default {"src":"/_next/static/media/icon-guild-more.869b121a.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};